import BrowserCheckService from './browser-check-service';

/***
 * A simple tool for checking what browser the current user is using the view the site.
 */
const browserCheck = angular
    .module('FacilityData.Common.BrowserCheck', [])
    .service('BrowserCheck', BrowserCheckService)
    .name;

export default browserCheck;


// WEBPACK FOOTER //
// ./app/common/browser-check/browser-check.js